// 该文件是根据环境变量自动进行判断平台
const PLATFORM_ENV = process.env.PLATFORM_ENV || 'h5'
const platform = require(`./${PLATFORM_ENV}/index.js`).default

export const request = platform.request
export const storage = platform.storage
export const modal = platform.modal
export const route = platform.route
export const intersectionObserver = platform.intersectionObserver



// WEBPACK FOOTER //
// ./src/npm/monitor/platform/index.js